import React, { FC, PropsWithChildren } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getHasAcceptedDisclaimer, setHasAcceptedDisclaimer } from '@store/appState/appSlice';
import { redirectToGoogle } from '@/helpers/redirectToGoogle';

interface DisclaimerGateProps extends PropsWithChildren {
  skipGate?: boolean;
}

export const DisclaimerGate: FC<DisclaimerGateProps> = ({ children, skipGate = false }) => {
  const dispatch = useDispatch();
  const hasAcceptedDisclaimer = useSelector(getHasAcceptedDisclaimer);
  const shouldShowDisclaimer = !skipGate && !hasAcceptedDisclaimer;

  const handleAgree = () => {
    dispatch(setHasAcceptedDisclaimer(true));
  };

  const handleDisagree = () => {
    redirectToGoogle();
  };

  return (
    <>
      {children}
      {shouldShowDisclaimer && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/70 px-6 backdrop-blur-md" role="dialog" aria-modal="true" aria-labelledby="disclaimer-title">
          <div className="w-full max-w-2xl rounded-lg bg-white p-8 shadow-2xl">
            <h2 id="disclaimer-title" className="text-2xl font-semibold text-black">
              Disclaimer
            </h2>
            <p className="mt-4 text-base leading-7 text-black">
              This app is for entertainment purposes only. It must never be used for training or any
              other air traffic control related matters.
            </p>
            <div className="mt-8 flex flex-col-reverse gap-3 sm:flex-row sm:justify-end">
              <button
                type="button"
                onClick={handleDisagree}
                className="rounded-md border border-black px-4 py-2 text-sm font-medium text-black"
              >
                Disagree
              </button>
              <button
                type="button"
                onClick={handleAgree}
                className="rounded-md bg-black px-4 py-2 text-sm font-medium text-white"
              >
                Agree
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};
